import styled, { css } from 'styled-components';
import { T as Text } from '../../Text/Text-CO4HftGt.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { B as Box } from '../../Box/Box-CRqR6LEm.js';

const Main = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-u3bskh-0"
})(["display:flex;flex:1;align-items:flex-start;padding:", ";gap:", ";justify-content:", ";color:", ";", " background-color:", ";:hover{background-color:", ";}", " ", ""], ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  $contentPosition
}) => $contentPosition, ({
  theme
}) => theme.text.color.default, isMobile(css(["padding:", ";gap:", ";"], ({
  theme
}) => theme.spacing.small.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile)), ({
  theme
}) => theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.selectableContainer.backgroundColor.hover, ({
  $disabled
}) => $disabled && css(["color:", ";background-color:", ";:hover{background-color:", ";}"], ({
  theme
}) => theme.text.color.unavailable, ({
  theme
}) => theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.selectableContainer.backgroundColor.default), ({
  $checked
}) => $checked && css(["background-color:", ";:hover{background-color:", ";}", ""], ({
  theme
}) => theme.selectableContainer.backgroundColor.selected, ({
  theme
}) => theme.selectableContainer.backgroundColor.selected, ({
  $disabled
}) => $disabled && css(["color:", ";"], ({
  theme
}) => theme.text.color.unavailable)));
const rowChildMixin = /*#__PURE__*/css(["border-inline-start-width:", ";border-inline-end-width:", ";"], ({
  theme
}) => theme.selectableContainer.borderWidth.default, ({
  theme
}) => theme.selectableContainer.borderWidth.default);
const columnChildMixin = /*#__PURE__*/css(["border-block-start-width:", ";border-block-end-width:", ";"], ({
  theme
}) => theme.selectableContainer.borderWidth.default, ({
  theme
}) => theme.selectableContainer.borderWidth.default);
const childMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowChildMixin : columnChildMixin);
const checkedRowChildMixin = /*#__PURE__*/css(["border-inline-start-width:", ";border-inline-end-width:", ";"], ({
  theme
}) => theme.selectableContainer.borderWidth.selected, ({
  theme
}) => theme.selectableContainer.borderWidth.selected);
const checkedColumnChildMixin = /*#__PURE__*/css(["border-block-start-width:", ";border-block-end-width:", ";"], ({
  theme
}) => theme.selectableContainer.borderWidth.selected, ({
  theme
}) => theme.selectableContainer.borderWidth.selected);
const checkedChildMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? checkedRowChildMixin : checkedColumnChildMixin);
const rowContainerChildrenMixin = /*#__PURE__*/css(["border-inline-end-width:0px;"]);
const columnContainerChildrenMixin = /*#__PURE__*/css(["border-block-end-width:0px;"]);
const containerChildrenMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowContainerChildrenMixin : columnContainerChildrenMixin);
const containerChildrenBorderRadiusMixin = /*#__PURE__*/css(["", ""], ({
  theme
}) => `calc(${theme.selectableContainer.borderRadius} - ${theme.selectableContainer.borderWidth.default})`);
const rowContainerFirstChildMixin = /*#__PURE__*/css(["border-start-start-radius:", ";border-end-start-radius:", ";border-inline-start-width:0px;"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const columnContainerFirstChildMixin = /*#__PURE__*/css(["border-start-start-radius:", ";border-start-end-radius:", ";border-block-start-width:0px;"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const containerFirstChildMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowContainerFirstChildMixin : columnContainerFirstChildMixin);
const rowContainerLastChildMixin = /*#__PURE__*/css(["border-start-end-radius:", ";border-end-end-radius:", ";"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const columnContainerLastChildMixin = /*#__PURE__*/css(["border-end-start-radius:", ";border-end-end-radius:", ";"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const containerLastChildMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowContainerLastChildMixin : columnContainerLastChildMixin);
const checkedContainerChildrenBorderRadiusMixin = /*#__PURE__*/css(["", ""], ({
  theme
}) => `calc(${theme.selectableContainer.borderRadius} - ${theme.selectableContainer.borderWidth.selected})`);
const checkedRowContainerFirstChildMixin = /*#__PURE__*/css(["border-start-start-radius:", ";border-end-start-radius:", ";border-inline-start-width:0px;"], checkedContainerChildrenBorderRadiusMixin, checkedContainerChildrenBorderRadiusMixin);
const checkedColumnContainerFirstChildMixin = /*#__PURE__*/css(["border-start-start-radius:", ";border-start-end-radius:", ";border-block-start-width:0px;"], checkedContainerChildrenBorderRadiusMixin, checkedContainerChildrenBorderRadiusMixin);
const checkedContainerFirstChildMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? checkedRowContainerFirstChildMixin : checkedColumnContainerFirstChildMixin);
const checkedRowContainerLastChildMixin = /*#__PURE__*/css(["border-start-end-radius:", ";border-end-end-radius:", ";"], checkedContainerChildrenBorderRadiusMixin, checkedContainerChildrenBorderRadiusMixin);
const checkedColumnContainerLastChildMixin = /*#__PURE__*/css(["border-end-start-radius:", ";border-end-end-radius:", ";"], checkedContainerChildrenBorderRadiusMixin, checkedContainerChildrenBorderRadiusMixin);
const checkedContainerLastChildMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? checkedRowContainerLastChildMixin : checkedColumnContainerLastChildMixin);
const rowChildHideBorderMixin = /*#__PURE__*/css(["", ""], ({
  hideStartBorder
}) => hideStartBorder && css(["border-inline-start-width:0px;"]));
const columnChildHideBorderMixin = /*#__PURE__*/css(["", ""], ({
  hideStartBorder
}) => hideStartBorder && css(["border-block-start-width:0px;"]));
const childHideBorderMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowChildHideBorderMixin : columnChildHideBorderMixin);
const ChildBox = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-40026394__sc-u3bskh-1"
})(["border-radius:initial;border-style:solid;border-width:0px;", " &&&{", "}"], ({
  $flex
}) => typeof $flex === 'number' && `
    flex: ${$flex};
  `, childHideBorderMixin);
const Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-u3bskh-2"
})(["overflow-x:auto;font:", ";background-color:", ";border-radius:", ";border-style:solid;color:", ";user-select:auto;display:flex;flex-direction:", ";@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,border-color 100ms ease;}", " border-width:", ";border-color:", ";:hover{border-color:", ";}", "{border-color:", ";", " ", " :first-of-type{", "}:last-of-type{", "}:hover{border-color:", ";}}", " ", " ", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.selectableContainer.borderRadius, ({
  theme
}) => theme.text.color.default, ({
  $direction
}) => $direction === 'row' ? 'row' : 'column', isMobile(css(["font:", ";flex:1;"], ({
  theme
}) => theme.font.text.base.mobile)), ({
  theme
}) => theme.selectableContainer.borderWidth.default, ({
  theme
}) => theme.selectableContainer.borderColor.default, ({
  theme
}) => theme.selectableContainer.borderColor.hover, ChildBox, ({
  theme
}) => theme.selectableContainer.borderColor.default, childMixin, containerChildrenMixin, containerFirstChildMixin, containerLastChildMixin, ({
  theme
}) => theme.selectableContainer.borderColor.hover, ({
  $disabled
}) => $disabled && css(["outline:none;opacity:1;border-color:", ";:hover{border-color:", ";}", "{border-color:", ";:hover{border-color:", ";}}"], ({
  theme
}) => theme.selectableContainer.borderColor.default, ({
  theme
}) => theme.selectableContainer.borderColor.default, ChildBox, ({
  theme
}) => theme.selectableContainer.borderColor.default, ({
  theme
}) => theme.selectableContainer.borderColor.default), ({
  $checked
}) => $checked && css(["margin-block-start:", ";margin-inline-start:", ";border-width:", ";border-color:", ";:hover{border-color:", ";}", "{border-color:", ";", " ", " :first-of-type{", "}:last-of-type{", "}:hover{border-color:", ";}}"], ({
  theme
}) => `calc(${theme.selectableContainer.borderWidth.default} - ${theme.selectableContainer.borderWidth.selected})`, ({
  theme
}) => `calc(${theme.selectableContainer.borderWidth.default} - ${theme.selectableContainer.borderWidth.selected})`, ({
  theme
}) => theme.selectableContainer.borderWidth.selected, ({
  theme
}) => theme.selectableContainer.borderColor.selected, ({
  theme
}) => theme.selectableContainer.borderColor.selected, ChildBox, ({
  theme
}) => theme.selectableContainer.borderColor.selected, checkedChildMixin, containerChildrenMixin, checkedContainerFirstChildMixin, checkedContainerLastChildMixin, ({
  theme
}) => theme.selectableContainer.borderColor.selected), ({
  $focusVisible
}) => $focusVisible && css([":has(:focus-visible){", "}@supports not selector(:focus-visible){", "}"], focusOutline, focusOutline));
const TileControlText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40026394__sc-u3bskh-3"
})(["text-align:start;"]);
const TileControlTextContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-u3bskh-4"
})(["display:flex;flex-direction:column;gap:", ";"], ({
  theme
}) => theme.spacing.xxsmall.default);
const IconWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-u3bskh-5"
})([""]);
const SubText = /*#__PURE__*/styled(TileControlText).withConfig({
  componentId: "sc-storm-ui-40026394__sc-u3bskh-6"
})(["", ""], ({
  $disabled
}) => !$disabled && css(["color:", ";"], ({
  theme
}) => theme.text.color.tertiary));

export { Container as C, IconWrapper as I, Main as M, SubText as S, TileControlTextContainer as T, ChildBox as a, TileControlText as b };
//# sourceMappingURL=Tile.styles-N6j8NPOo.js.map
